import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicBusinessProjectFormBuilderRoute: InvariantJiraRoute = {
	name: 'classic-business-form-builder',
	path: '/jira/core/projects/:projectKey/form/:formId/builder',
	exact: true,
};
